import React from 'react';
import { Card } from '../ui/Card';
import { DollarSignIcon, FileTextIcon, AlertTriangleIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
export function FinancialTab({
  contact
}) {
  const formatCurrency = amount => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };
  const formatDate = dateString => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'paid':
        return <CheckCircleIcon className="w-4 h-4 text-green-500" data-id="element-310" />;
      case 'pending':
        return <ClockIcon className="w-4 h-4 text-yellow-500" data-id="element-311" />;
      case 'overdue':
        return <AlertTriangleIcon className="w-4 h-4 text-red-500" data-id="element-312" />;
      default:
        return null;
    }
  };
  return <div data-id="element-313">
      <Card title="Financial Summary" data-id="element-314">
        <div className="flex flex-col md:flex-row md:items-center gap-6" data-id="element-315">
          <div className="flex items-center gap-3" data-id="element-316">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-317">
              <DollarSignIcon className="w-6 h-6 text-blue-600" data-id="element-318" />
            </div>
            <div data-id="element-319">
              <h4 className="text-sm font-medium text-gray-500" data-id="element-320">
                Account Balance
              </h4>
              <p className="text-xl font-semibold text-gray-800" data-id="element-321">
                {formatCurrency(contact.accountBalance)}
              </p>
            </div>
          </div>
          <div className="border-l border-gray-200 h-12 hidden md:block" data-id="element-322"></div>
          <div data-id="element-323">
            <h4 className="text-sm font-medium text-gray-500" data-id="element-324">
              Payment Status
            </h4>
            <div className="flex gap-2 mt-1" data-id="element-325">
              {contact.invoices.some(inv => inv.status === 'overdue') ? <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs flex items-center gap-1" data-id="element-326">
                  <AlertTriangleIcon className="w-3 h-3" data-id="element-327" /> Overdue
                </span> : <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs flex items-center gap-1" data-id="element-328">
                  <CheckCircleIcon className="w-3 h-3" data-id="element-329" /> Current
                </span>}
            </div>
          </div>
        </div>
      </Card>
      <Card title="Invoices" actions={<button className="text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1" data-id="element-331">
            <FileTextIcon className="w-4 h-4" data-id="element-332" /> New Invoice
          </button>} data-id="element-330">
        <div className="overflow-x-auto" data-id="element-333">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-334">
            <thead data-id="element-335">
              <tr data-id="element-336">
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-337">
                  Invoice #
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-338">
                  Date
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-339">
                  Amount
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-340">
                  Status
                </th>
                <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-341">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-342">
              {contact.invoices.map(invoice => <tr key={invoice.id} className="hover:bg-gray-50" data-id="element-343">
                  <td className="px-3 py-3 text-sm text-gray-900" data-id="element-344">
                    {invoice.id}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-500" data-id="element-345">
                    {formatDate(invoice.date)}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-900" data-id="element-346">
                    {formatCurrency(invoice.amount)}
                  </td>
                  <td className="px-3 py-3 text-sm" data-id="element-347">
                    <div className="flex items-center gap-1" data-id="element-348">
                      {getStatusIcon(invoice.status)}
                      <span className={`capitalize ${invoice.status === 'paid' ? 'text-green-700' : invoice.status === 'overdue' ? 'text-red-700' : 'text-yellow-700'}`} data-id="element-349">
                        {invoice.status}
                      </span>
                    </div>
                  </td>
                  <td className="px-3 py-3 text-sm text-right" data-id="element-350">
                    <button className="text-blue-600 hover:text-blue-800" data-id="element-351">
                      View
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}